import React, { Component } from 'react';
import {WebSocketEventEmitter} from "../Websockets/WebSocketEventEmitter";

class Test extends Component {
  componentDidMount = () => {
  }
  
  markComplete = () => {
    const data = {
      'eventSource': 'frontend-testing',
      data:{
        sender: 'Arya Stark',
        message: 'Test-ProgressBrienne completed work instruction #2',
        process: 'Progression',
        read: false,
        module: 'Work Instruction'
      }
    }
    WebSocketEventEmitter.emit('WSListener', data);
  }

  signin = () => {
    const data = {
      'eventSource': 'frontend-testing', 
      data: {
        sender: 'Arya Stark',
        message: 'Test-Arya Stark has signed in.',
        process: 'User Activity',
        read: false,
        module: 'Log In Form'
      }
    }
    WebSocketEventEmitter.emit('WSListener', data);
  }

  submitFeedback = () => {
    const data = {
      'eventSource': 'frontend-testing',
      data: {
        sender: 'Brienne',
        message: "Sam's Warning/Cautions Instruction: 607f4bda5794d833786642ef: Test-Brienne submitted a feedback.",
        process: 'New Feedback',
        read: false,
        module: 'Feedback'
      }
    }
    WebSocketEventEmitter.emit('WSListener', data);
  }

  uploadModel = () => {
    const data = {
      'eventSource': 'frontend-testing',
      data: {
        sender: 'Brienne',
        message: 'Brienne uploaded a new model.',
        process: 'Model Uploader',
        read: false,
        module: 'Model'
      }
    }


    WebSocketEventEmitter.emit('WSListener', data);
  }

  render = () => (
      <div className="test-buttons">
        <button onClick={this.signin}>Sign In</button>
        <button onClick={this.markComplete}>Mark Task Complete</button>
        <button onClick={this.submitFeedback}>Submit Feedback</button>
        <button onClick={this.uploadModel}>Upload Model</button>
      </div>
    )
}

export default Test;


